{
  "slug": "leonardo-da-vinci-iq",
  "title": "Leonardo da Vinci IQ: what is actually known?",
  "description": "A careful review of reported Leonardo da Vinci IQ claims and why popular numbers are unverified.",
  "category": "Famous people and IQ claims",
  "sections": [
    {
      "heading": "Documented achievement",
      "paragraphs": [
        "Leonardo’s surviving art, notebooks, anatomical studies, and engineering ideas demonstrate wide-ranging accomplishment.",
        "Achievement can involve knowledge, persistence, creativity, collaboration, opportunity, and specialist expertise. It cannot be translated into a unique IQ number."
      ]
    },
    {
      "heading": "Evidence behind the reported number",
      "paragraphs": [
        "He lived centuries before intelligence tests. Any precise IQ assigned to him is a modern retrospective guess.",
        "A credible claim would identify the instrument, version, date, administration conditions, norm group, score type, and a reliable primary record. Viral lists rarely provide that chain."
      ]
    },
    {
      "heading": "Responsible conclusion",
      "paragraphs": [
        "Treat a number as unverified unless a primary record is available. Separate admiration for achievement from psychometric measurement.",
        "The conclusion is not that the person lacked ability; it is that the precise number is unknown."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [
    {
      "label": "Royal Collection Trust — Leonardo da Vinci",
      "url": "https://www.rct.uk/collection/themes/trails/leonardo-da-vinci"
    }
  ],
  "faqs": [
    {
      "question": "What was Leonardo da Vinci’s IQ?",
      "answer": "No authenticated standardized score is publicly established. Precise values repeated online should be treated as speculation."
    },
    {
      "question": "Can achievement be converted into IQ?",
      "answer": "No. Achievement and test performance overlap only partly and use different evidence."
    }
  ],
  "summary": "A careful review of reported Leonardo da Vinci IQ claims and why popular numbers are unverified. Content reviewed 18 July 2026."
}
